import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { selectUserResult, currentUserSelector } from 'selectors';

import Layout from 'Components/Layout/Layout';

import { Alert } from 'frontend-component-library';

class ResultsErrorPage extends PureComponent {
  formatSupportEmail = () => {
    const { currentUserResult, user } = this.props;
    const resultUUID = currentUserResult.uuid;
    const userUUID = user.uuid;
    const emailAddress = 'support@delphia.com';
    const subject = 'Undergraduate Recommendation Support';
    const body = `I was taking the University Recommender survey and I encountered an error message.
${userUUID ? ` My User UUID is: ${userUUID}.` : ''}
${resultUUID ? ` My Result UUID is: ${resultUUID}.` : ''}
 Please alert me when the issue has been fixed.%0D%0A%0D%0A
Please don't delete the following, our support team needs it to send your result if we fix the issue.%0D%0A
${userUUID ? `User UUID: ${userUUID}.%0D%0A` : ''}
${resultUUID ? `Result UUID: ${resultUUID}.` : ''}`;

    return `mailto:${emailAddress}?subject=${subject}&body=${body}`;
  };

  render() {
    return (
      <Layout>
        <div className="ResultsErrorPage">
          <Alert type="error">
            <p>
              We are sorry, due to an error we are unable to generate a result
              for you at this time. Our support team has been alerted of the
              problem.
            </p>
            <p>
              Please <a href={this.formatSupportEmail()}>click here</a> to
              contact us. We have added your Result ID to your support email
              template, so if we are able to fix the problem, we will be able to
              email you a link to your results.
            </p>
          </Alert>
        </div>
      </Layout>
    );
  }
}

ResultsErrorPage.propTypes = {
  currentUserResult: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    currentUserResult: selectUserResult(state),
    user: currentUserSelector(state),
  };
}

export default connect(mapStateToProps)(ResultsErrorPage);



// WEBPACK FOOTER //
// ./src/Components/Pages/ResultsErrorPage.js